export default __webpack_public_path__ + "static/media/delete_icon.aef4c63e.svg";